import React, { useEffect, useState } from 'react';
import { CardHeader } from '@mui/material';
import { StyledCellLink, Percentage, Weight } from '../Common/DataGrid/CellComponents';
import { getDateRangeFilterOperator, getRangeFilterOperator } from '../Common/DataGrid/FilterComponents';
import { select_commonCellProps, text_commonCellProps } from '../Common/DataGrid/utils';
import {
    DataGrid,
    PageTitleWithToolTip
} from '../Common';
import Routes from '../../routes';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import { fetchFilterValues } from '../../utils';

const dateRangeFilterOperator = getDateRangeFilterOperator({});
const rangeFilterOperator = getRangeFilterOperator({});

const columns = [
    {
        field: 'region',
        headerName: 'Region',
        ...text_commonCellProps
    },
    {
        field: 'locationName',
        headerName: 'Location',
        ...select_commonCellProps,
        renderCell: ({ row: { locationName, locationId } }) => (
            <StyledCellLink
                path={`/Location/${locationId}`}
                text={locationName}
                from={"Compliance Center"}
                primaryLink={true}
            />
        )
    },
    {
        field: 'assetName',
        headerName: 'Asset Name',
        ...text_commonCellProps,
        renderCell: ({ row: { assetName, assetId } }) => (
            <StyledCellLink
                path={`/Inventory/${assetId}`}
                text={assetName}
                from={"Compliance Center"}
                primaryLink={true}
            />
        )
    },
    {
        field: 'assetType',
        headerName: 'Type',
        ...select_commonCellProps
    },
    {
        field: 'materialTypeName',
        headerName: 'Material Type',
        ...select_commonCellProps
    },
    {
        field: 'gasCapacityString',
        headerName: 'Gas Capacity',
        valueGetter: (value) => value,
        filterOperators: rangeFilterOperator
    },
    {
        field: 'currentGasWeightString',
        headerName: 'Current Weight',
        valueGetter: (value) => value,
        filterOperators: rangeFilterOperator
    },
    {
        field: 'calendarYearLeakRate',
        headerName: 'Calendar Year Leak Rate %',
        valueGetter: (value) => value,
        filterOperators: rangeFilterOperator,
        renderCell: ({ row: { calendarYearLeakRate } }) => <Percentage value={calendarYearLeakRate} />
    },
]

const ChronicallyLeaky = () => {

    const [filters, setFilters] = useState([]);

    const fetchFilters = async () => {
        const filters = await fetchFilterValues(Routes.Dashboard.ChronicallyLeakyDropdown());
        setFilters(filters);
    };

    useEffect(() => { fetchFilters() }, []);

    return (
        <DataGrid
            url={Routes.Dashboard.ChronicallyLeaky(false)}
            exportButtonURL={Routes.Dashboard.ChronicallyLeaky(true)}
            filterOptions={filters}
            columns={columns}
            rowCount="5"
            tableId={'chronically-leaking-systems-table'}
            exportFileName={"CHRONICALLY LEAKING SYSTEMS"}
            exportButtonAlt={"Export CHRONICALLY LEAKING SYSTEMS (.csv)"}
            noResultText="Oops...It is empty here..."
            noResultText2="Create a new asset or change your search criteria."
            dataGridSx={{
                border: 'none'
            }}
        />
    );
}

export default ChronicallyLeaky;
